/**
 * useResendOutreachMessages — the bulk Retry (2.10 C2) over Go's
 * `resend_messages` operation. No onSuccess invalidation: nothing has changed
 * when the 202 lands — OperationProgress's onDone refetches rows once items
 * settle, the same contract as useOutreachEntryActions.removeMany.
 */
import { useMutation } from '@tanstack/react-query';
import { resendOutreachMessages } from '../api/outreachApi';

export interface ResendMessagesVars {
  messageIds: number[];
}

export function useResendOutreachMessages(campaignId: string) {
  return useMutation<{ operationId: string }, Error, ResendMessagesVars>({
    mutationFn: (v) => resendOutreachMessages(campaignId, v.messageIds, crypto.randomUUID()),
  });
}
